import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import { MERCHANT_CONSULT_PHONE } from '@hlj/hlj-constant'
import { isSiDaProperty } from '@merchant-backend/util'
import { isEmojiCharacter } from '@util'
import 'antd4/lib/grid/style/index.css'
import { Checkbox, Col, InputNumber, message, Radio, Row } from 'hljd'
import _get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import CheckInput from '../../CheckInput'
import { checkoutArea, getText } from '../../utils'
import constant from '../constant'
import SelfInput from '../Input'
import PayWay, { PayWayModal } from './PayWay/index'
import PlaceSelect from './PlaceSelect'
import ScenicSpotImgs from './ScenicSpotImgs'
import Style from './style.module.less'

const FormItem = Form.Item
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 }
  }
}
@Form.create({
  onValuesChange: (props, changedValues, allValues) => {
    const name = Object.keys(changedValues)[0]
    const v = changedValues[name]
    if (name === 'actual_price' && !isNaN(Number(v))) {
      allValues['market_price'] = v
    }
    // 修改婚纱摄影、婚纱礼服、婚戒的子分类，会影响到其他地方的选项，所以特殊处理
    // 婚纱摄影子分类
    if (name === 'second_category_id' || name === 'jewelry_type') {
      props.store.centerStore.onSecondCategoryChange(v)
    }

    if (name === 'scenicSpot') {
      props.store.centerStore.onScenicSpotChange(v)
    }

    // // 婚戒子分类
    // if (name === 'jewelry_type') {
    //   props.store.centerStore.onJewelryTypeChange(changedValues['jewelry_type'])
    // }
    if (props.store.onFormChange) {
      props.store.onFormChange(allValues) // 就是把值都存到store的form_values中
    }
  }
})
@observer
export default class extends Component {
  componentDidMount = () => {
    this.props.store.getForm('form', this.props.form)
    if (this.props.store.centerStore.property_id == 6) {
      if (!this.props.store.centerStore.isEdit) {
        this.queryScenicSpot(undefined, 'create')
      } else {
        this.queryScenicSpot()
      }
    }
  }

  isFirst = true
  componentDidUpdate = () => {
    const {
      centerStore: {
        tag_list = [],
        setTagValues,
        property_id,
        weddingPhotoType,
        detailData
      }
    } = this.props.store
    if (
      property_id == 6 &&
      weddingPhotoType == 4 &&
      detailData.tags &&
      tag_list.length > 0 &&
      this.isFirst
    ) {
      setTagValues(this.initTagList(detailData.tags, tag_list))
      this.isFirst = false
    }
  }

  renderActivePrice = (property_id, getFieldDecorator, form_values) => {
    const relation = +property_id < 6 || +property_id > 11

    const TEXT = getText()
    return (
      <div>
        <div>
          <FormItem label="市场价" {...formItemLayout}>
            <div className={Style.after}>
              <SelfInput after="元">
                <FormItem {...formItemLayout}>
                  {getFieldDecorator('market_price', {
                    initialValue: form_values.market_price
                      ? +form_values.market_price
                      : '',
                    rules: [
                      {
                        validator: (rule, value, callback) => {
                          let reg = /^[1-9]\d*$/g
                          if (!reg.test(value)) {
                            callback('请输入正整数')
                          }
                          if (value && value < form_values.actual_price) {
                            callback('售价不能大于市场价')
                          }
                          callback()
                        }
                      }
                    ]
                  })(
                    <InputNumber
                      placeholder={`请输入${TEXT}的定金金额`}
                      style={{ width: 240 }}
                    />
                  )}
                </FormItem>
              </SelfInput>
            </div>
          </FormItem>
        </div>

        <div>
          <FormItem
            label={relation ? `合作价` : `平台售价`}
            {...formItemLayout}
          >
            <div className={Style.after}>
              <SelfInput after="元">
                <FormItem {...formItemLayout}>
                  {getFieldDecorator('actual_price', {
                    initialValue: form_values.actual_price
                      ? +form_values.actual_price
                      : '',
                    rules: [
                      {
                        validator: (rule, value, callback) => {
                          let reg = /^[1-9]\d*$/g
                          if (!reg.test(value)) {
                            callback('请输入正整数')
                          }
                          if (value && value < form_values.actual_price) {
                            callback('售价不能大于市场价')
                          }
                          callback()
                        }
                      }
                    ]
                  })(
                    <InputNumber
                      placeholder={`请输入${TEXT}的定金金额`}
                      style={{ width: 240 }}
                    />
                  )}
                </FormItem>
              </SelfInput>
            </div>
          </FormItem>
        </div>

        <div>
          <FormItem
            label={relation ? `活动价` : `活动最低价`}
            {...formItemLayout}
          >
            <div className={Style.after}>
              <SelfInput after="元">
                <FormItem {...formItemLayout}>
                  {getFieldDecorator('sale_price', {
                    initialValue: form_values.sale_price
                  })(
                    <InputNumber
                      placeholder={`请输入${TEXT}的定金金额`}
                      style={{ width: 240 }}
                    />
                  )}
                </FormItem>
              </SelfInput>
            </div>
          </FormItem>
        </div>

        <div>
          <FormItem label={relation ? `结算价` : `合作价`} {...formItemLayout}>
            <div className={Style.after}>
              <SelfInput after="元">
                <FormItem {...formItemLayout}>
                  {getFieldDecorator('base_price', {
                    initialValue: form_values.base_price
                  })(
                    <InputNumber
                      placeholder={
                        relation
                          ? `请输入${TEXT}的结算价，需小于${TEXT}活动价`
                          : `请输入${TEXT}在婚礼纪的内部合作价，需小于活动最低价`
                      }
                      style={{ width: 240 }}
                    />
                  )}
                </FormItem>
              </SelfInput>
            </div>
          </FormItem>
        </div>

        <div className={Style['title-tips']}>
          <Row>
            <Col span={3} />
            <Col span={15}>
              <div className={Style['tip-item']}>
                <p>
                  {relation
                    ? `市场价、${TEXT}合作价、${TEXT}活动价、结算价一经设置后无法修改；`
                    : `市场价、平台售价、活动最低价、合作价一经设置后无法修改；`}
                </p>
                <p
                >{`如需修改请联系负责您的BD或拨打商家热线${MERCHANT_CONSULT_PHONE}申请修改`}</p>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    )
  }

  // 根据property_id、weddingPhotoType、性别等获取tips
  getTips = () => {
    const {
      property_id,
      centerStore: { gender, weddingPhotoType }
    } = this.props.store
    let tips = constant.user_tips[property_id]
    if (typeof tips === 'function') {
      tips = tips(this.props.store.centerStore.second_category_id)
    }
    if (property_id == 6) {
      const children = tips.children.find(item => item.id == weddingPhotoType)
      return children || tips
    } else if (property_id == 12) {
      const children = tips.children[0]
      if (!gender) {
        return tips
      } else if (gender == 1) {
        return {}
      } else {
        return children
      }
    } else {
      return tips
    }
  }

  checkZero = (rule, value, callback) => {
    if (!value) {
      callback(`请输入${isSiDaProperty() ? '订金' : '定金'}金额`)
    }
    let reg = /^[1-9]\d*$/g
    if (!reg.test(+value)) {
      callback('请输入正整数')
    }
    let actual_price = this.props.store.form_values.actual_price
    if (actual_price && actual_price < value) {
      callback('定金需小于售价')
    }
    callback()
  }

  checkEmoji = (rule, value, callback) => {
    if (value && isEmojiCharacter(value)) {
      callback('禁止输入表情符号')
    }
    callback()
  }

  checkActualPrice = (rule, value, callback) => {
    const { isSingle, gender } = this.props.store.centerStore
    const min = gender == 1 ? 199 : 299
    value = Number(value)
    if (!!value && isSingle && value < min) {
      callback(`单品售价不得低于${min}元`)
    }
    callback()
  }

  initTagList = (tagIds, tag_list) => {
    if (!tag_list) {
      return []
    }
    if (!tagIds || tagIds.length == 0) {
      return [...toJS(tag_list)]
    }

    const tags = tagIds.map(item => item.mark_id)
    const tempTags = [...toJS(tag_list)]
    for (let i = 0; i < tempTags.length; i++) {
      for (let j = 0; j < tempTags[i].children.length; j++) {
        if (tags.includes(tempTags[i].children[j].mark_id)) {
          tempTags[i].children[j].isActive = true
        }
      }
    }
    return [...tempTags]
  }

  getTourType = (list, id, value, child) => {
    list.forEach(childItem => {
      if (childItem.id == '3377' || childItem.id == '3421') {
        childItem.children.forEach(item => {
          item.isActive = false
        })
        childItem.children.forEach(item => {
          if (item.id == id) {
            item.isActive = true
            this.props.form.setFieldsValue({ destination: 1 })
          }
        })
      }
    })
    this.props.store.centerStore.setTagValues(toJS(list))
  }

  // 请求取景地，不做任何逻辑处理
  queryScenicSpot = (id, type) => {
    const { queryScenicSpotList } = this.props.store
    queryScenicSpotList(id, type)
  }

  render() {
    const {
      form: { getFieldDecorator, getFieldError },
      store: { centerStore }
    } = this.props

    const isOnActivity = !!centerStore.detailData.rule // 是否在活动中

    const {
      merchant_info,
      property_id,
      form_values,
      centerStore: {
        isSingle,
        isDraft,
        id,
        tag_list,
        detailData,
        stepTwoStore: { sessionServiceStore }
      },
      seriesList,
      weddingPhotoType,
      secondCategoryList, // 子分类列表
      historyOrderGift, // 历史订单礼列表
      historyPayAllGift, // 历史自定义全款礼
      payWayModal,
      togglePayWayModal,
      scenicSpotList,
      selectedScenicSpot,
      setScenicSpot,
      resetScenicSpotList,
      resetScenicSpotImg,
      removeDeletedScenicSpotList
    } = this.props.store
    const vipTagList = toJS(this.props.store.vipTagList)
    const tip = this.getTips() || {} // 各提示语（如标题下的注释）
    const title = getText(isSingle)

    const areaList = tag_list
    const area = form_values.area
      ? String(form_values.area)
      : checkoutArea(areaList, this.props.form)

    const renderAreaList =
      ((areaList || []).find(child => child.id == area) || {}).children || []

    /*
      property_id 对应的商家类型
      1： 全部
      2： 婚礼策划
      6： 婚纱摄影
      7： 婚礼摄影
      8： 婚礼摄像
      9： 婚礼跟妆
      11： 婚礼司仪
      12： 婚纱礼服
      13： 婚礼酒店
      14： 婚戒首饰
      15： 花艺甜品
    */

    return (
      <div className={Style.formWrapper}>
        {detailData &&
          !isEmpty(detailData.reason) && (
            <div className={Style.failReason}>
              <img
                src="//qnm.hunliji.com/FjwtPkLNVZQQDGQw6gCxUDl09Ruj"
                alt="icon"
                width="16"
              />
              审核不通过原因：{detailData.reason}
            </div>
          )}
        <div className={Style.formMain}>
          {!isSingle &&
            (property_id == '6' || property_id == '12') && (
              <FormItem label={`套餐类型`} {...formItemLayout}>
                {getFieldDecorator('second_category_id', {
                  initialValue:
                    detailData.second_category_id ||
                    String(_get(secondCategoryList, '[0].id', '')),
                  rules: [
                    {
                      required: true,
                      message: `请选择套餐类型`
                    }
                  ]
                })(
                  <Radio.Group
                    onChange={e => {
                      // antd3 表单收集值的时机与onChange不一致，会比onChange慢一点
                      // 因此不使用setTimeout的时候，resetScenicSpotList 里面修改 scenicSpot 会率先触发 onValuesChange
                      // 导致这个时候onValuesChange 会先进 === 'scenicSpot' 判断
                      // 里面拿到的 second_category_id 并不是最新的，从而导致后续逻辑出错
                      setTimeout(() => {
                        resetScenicSpotList()
                        resetScenicSpotImg()
                        sessionServiceStore.initItineraryList([])
                        e.target.value == 1 &&
                          this.queryScenicSpot(undefined, 'create')
                      })
                    }}
                    disabled={id && !isDraft}
                  >
                    {secondCategoryList.map(({ id, name }) => {
                      return (
                        <Radio value={String(id)} key={id}>
                          {name}
                        </Radio>
                      )
                    })}
                  </Radio.Group>
                )}
              </FormItem>
            )}
          {
            <FormItem>
              {property_id == '14' && (
                <>
                  <FormItem label="商品类别" {...formItemLayout}>
                    {getFieldDecorator('jewelry_type', {
                      initialValue: detailData.jewelry_type || '1',
                      rules: [
                        {
                          required: true,
                          message: '请选择婚戒类型'
                        }
                      ]
                    })(
                      <Radio.Group>
                        {secondCategoryList.map(({ id, name }) => {
                          return (
                            <Radio value={String(id)} key={id}>
                              {name}
                            </Radio>
                          )
                        })}
                      </Radio.Group>
                    )}
                  </FormItem>

                  {!!seriesList.length && (
                    <FormItem label="所属系列（多选）：" {...formItemLayout}>
                      {getFieldDecorator('series_id', {
                        initialValue: form_values.series_id || [],
                        rules: [
                          {
                            required: false
                          }
                        ]
                      })(
                        <Checkbox.Group>
                          {seriesList.map(({ id, title }) => (
                            <Checkbox key={id} value={id}>
                              {title}
                            </Checkbox>
                          ))}
                        </Checkbox.Group>
                      )}
                    </FormItem>
                  )}
                  {!seriesList.length && (
                    <FormItem label="所属系列（多选）：" {...formItemLayout}>
                      <p>暂无可选系列</p>
                    </FormItem>
                  )}
                </>
              )}
              {
                <div>
                  <FormItem
                    label={`${title}标题`}
                    {...formItemLayout}
                    extra={'建议名称总长度在12-24字，禁止输入表情符号'}
                  >
                    <SelfInput
                      showTotal={true}
                      maxLeng={24}
                      value={form_values.title}
                    >
                      {getFieldDecorator('title', {
                        initialValue: form_values.title,
                        rules: [
                          {
                            required: true,
                            message: `请输入${title}标题`
                          },
                          {
                            min: 12,
                            message: `${title}标题字数不能少于12个字`
                          },
                          {
                            max: 24,
                            message: `${title}标题字数不能多于24个字`
                          },
                          {
                            validator: this.checkEmoji
                          }
                        ]
                      })(
                        <CheckInput
                          placeholder="建议标题以城市、营销点、风格、商家简称、优惠、服装套系命名"
                          style={{ width: 460 }}
                          maxLength={24}
                          type={1}
                          getFieldError={getFieldError}
                        />
                      )}
                    </SelfInput>
                  </FormItem>
                </div>
              }
              {/*--------------------------------------------------------标题下注释 */}
              {tip &&
                tip.ex && (
                  <div className={Style['title-tips']}>
                    <FormItem label=" " {...formItemLayout}>
                      <div className={Style['tip-item']}>
                        <p>{`${tip.keyword}`}</p>
                        <p>{`示例一：${tip.ex[0]}`}</p>
                        <p>{`示例二：${tip.ex[1]}`}</p>
                        <p>{`示例三：${tip.ex[2]}`}</p>
                        {tip.notice ? (
                          <p>
                            温馨提示：<span className={Style.notice}>
                              {tip.notice}
                            </span>
                          </p>
                        ) : (
                          ''
                        )}
                      </div>
                    </FormItem>
                  </div>
                )}

              {property_id == 2 && (
                <div>
                  <FormItem {...formItemLayout} label="场地">
                    {this.props.form.getFieldDecorator('place_type', {
                      initialValue: form_values.place_type,
                      rules: [
                        {
                          required: true,
                          message: '场地请至少选择一项'
                        }
                      ]
                    })(<PlaceSelect />)}
                  </FormItem>
                </div>
              )}

              {merchant_info.is_new_si_da == 1 &&
                this.renderActivePrice(
                  property_id,
                  getFieldDecorator,
                  form_values
                )}
              {/*----------------------------------------------------售价市场价 */}
              {merchant_info.is_new_si_da == 0 && (
                <div>
                  <div>
                    <FormItem label={`${title}售价`} {...formItemLayout}>
                      <SelfInput after="元" value={form_values.actual_price}>
                        {getFieldDecorator('actual_price', {
                          initialValue: form_values.actual_price
                            ? +form_values.actual_price
                            : '',
                          rules: [
                            { required: true, message: '必填项' },
                            { pattern: /^[1-9]\d*$/, message: '请输入正整数' },
                            {
                              validator: this.checkActualPrice
                            }
                          ]
                        })(
                          <InputNumber
                            disabled={isOnActivity}
                            placeholder={`请输入${title}在婚礼纪的标价`}
                            style={{ width: 240 }}
                          />
                        )}
                      </SelfInput>
                      {isOnActivity && (
                        <div style={{ lineHeight: '21px', color: '#ff5c5c' }}>
                          {title}在活动中，不可编辑售价
                        </div>
                      )}
                    </FormItem>
                  </div>
                  <div>
                    <FormItem label={`${title}市场价`} {...formItemLayout}>
                      <SelfInput after="元" value={form_values.market_price}>
                        {getFieldDecorator('market_price', {
                          initialValue: form_values.market_price
                            ? +form_values.market_price
                            : '',
                          rules: [
                            {
                              validator: (rule, value, callback) => {
                                let reg = /^[1-9]\d*$/g
                                if (!reg.test(value) && value) {
                                  callback('请输入正整数')
                                }
                                if (value && value < form_values.actual_price) {
                                  callback('售价不能大于市场价')
                                }
                                callback()
                              }
                            }
                          ]
                        })(
                          <InputNumber
                            placeholder={`请输入${title}在市面上的售价`}
                            style={{ width: 240 }}
                          />
                        )}
                      </SelfInput>
                    </FormItem>
                  </div>
                </div>
              )}
              {
                <Fragment>
                  {/*----------------------------------------------------付款方式 */}
                  <div className={Style.gather}>
                    <FormItem
                      label="付款方式"
                      {...formItemLayout}
                      extra={
                        isSiDaProperty() &&
                        form_values.earnest_money_support == 2 && (
                          <div style={{ position: 'relative', marginTop: 25 }}>
                            发布{getText()}则表示您同意<a
                              onClick={togglePayWayModal(true)}
                            >
                              婚礼纪订单付款及退款协议
                            </a>
                          </div>
                        )
                      }
                    >
                      <PayWayModal
                        visible={payWayModal}
                        onCancel={togglePayWayModal(false)}
                      />
                      {getFieldDecorator('earnest_money_support', {
                        initialValue: form_values.earnest_money_support || '2',
                        rules: [
                          {
                            required: true,
                            message: ''
                          }
                        ]
                      })(<PayWay disabled={isOnActivity} />)}
                      {form_values.earnest_money_support == 2 && (
                        <div
                          className={Style['after-item']}
                          style={{ left: '193px', display: 'flex' }}
                        >
                          <SelfInput
                            after="元"
                            value={form_values.earnest_money}
                          >
                            <FormItem>
                              {getFieldDecorator('earnest_money', {
                                initialValue: form_values.earnest_money
                                  ? +form_values.earnest_money
                                  : '',
                                rules:
                                  form_values.earnest_money_support == 2
                                    ? [
                                        {
                                          required:
                                            form_values.earnest_money_support ==
                                            2,
                                          message: ' '
                                        },
                                        {
                                          pattern: /^[1-9]\d*$/,
                                          message: '请输入正整数'
                                        },
                                        {
                                          validator: this.checkZero
                                        }
                                      ]
                                    : []
                              })(
                                <InputNumber
                                  placeholder={
                                    isSiDaProperty() ? `订金金额` : `定金金额`
                                  }
                                  style={{ width: 240 }}
                                  disabled={
                                    isOnActivity ||
                                    form_values.earnest_money_support != '2'
                                  }
                                />
                              )}
                            </FormItem>
                          </SelfInput>
                        </div>
                      )}
                      {isOnActivity && (
                        <div style={{ lineHeight: '21px', color: '#ff5c5c' }}>
                          {title}在活动中，不可编辑付款方式
                        </div>
                      )}
                    </FormItem>
                  </div>

                  {/*-----------------------------------------------------订单礼 */}
                  <div className={Style.gather}>
                    <FormItem label="订单礼" {...formItemLayout}>
                      <SelfInput
                        showTotal={true}
                        maxLeng={15}
                        value={form_values.order_gift}
                      >
                        {getFieldDecorator('order_gift', {
                          initialValue: form_values.order_gift,
                          rules: [
                            {
                              max: 15,
                              message: `字数不能多于15个字`
                            }
                          ]
                        })(
                          <CheckInput
                            placeholder={`请输入${title}的订单礼`}
                            style={{ width: 460 }}
                            maxLength={15}
                            dataSource={historyOrderGift}
                            getFieldError={getFieldError}
                            autoComplete
                          />
                        )}
                      </SelfInput>
                    </FormItem>
                  </div>

                  {/*--------------------------------------------------全款礼 */}
                  <div className={Style.gather}>
                    <FormItem label="全款礼" {...formItemLayout}>
                      {getFieldDecorator('pay_all_percent', {
                        initialValue: String(form_values.pay_all_percent || 0),
                        getValueFromEvent: e => {
                          this.props.form.setFields({
                            pay_all_gift: {
                              value: '',
                              error: []
                            }
                          })
                          return e.target.value
                        }
                      })(
                        <Radio.Group>
                          <Radio.Button value={'0'}>无</Radio.Button>
                          <Radio.Button value={'1'}>提供全款95折</Radio.Button>
                          <Radio.Button value={'2'}>自定义</Radio.Button>
                        </Radio.Group>
                      )}
                      {form_values.pay_all_percent == 2 && (
                        <div
                          className={Style['after-item']}
                          style={{ left: '250px', display: 'flex' }}
                        >
                          <SelfInput
                            showTotal={true}
                            maxLeng={15}
                            value={form_values.pay_all_gift}
                          >
                            <FormItem>
                              {getFieldDecorator('pay_all_gift', {
                                initialValue: form_values.pay_all_gift,
                                rules: [
                                  {
                                    required: form_values.pay_all_percent == 2,
                                    message: '必填项'
                                  },
                                  { max: 15, message: '内容请小于15个字' }
                                ]
                              })(
                                <CheckInput
                                  placeholder={`请输入${title}的全款礼`}
                                  style={{ width: 240 }}
                                  disabled={form_values.pay_all_percent != 2}
                                  maxLength={15}
                                  dataSource={historyPayAllGift}
                                  getFieldError={getFieldError}
                                  autoComplete
                                />
                              )}
                            </FormItem>
                          </SelfInput>
                        </div>
                      )}
                    </FormItem>
                  </div>
                </Fragment>
              }
              {weddingPhotoType == 4 && (
                <div>
                  <FormItem label={`旅拍目的地`} {...formItemLayout}>
                    {getFieldDecorator('area', {
                      initialValue: form_values.area
                        ? String(form_values.area)
                        : area,
                      rules: [
                        {
                          required: true,
                          message: '请选择旅拍目的地'
                        }
                      ]
                    })(
                      <Radio.Group>
                        <Radio.Button value="3377">国内</Radio.Button>
                        <Radio.Button value="3421">国外</Radio.Button>
                      </Radio.Group>
                    )}
                  </FormItem>
                </div>
              )}
              {/* 目的地 */}
              {area && !!renderAreaList.length ? (
                <div className={Style.tags}>
                  <div>
                    <FormItem label=" " {...formItemLayout}>
                      {!!renderAreaList.length && (
                        <Radio.Group
                          value={
                            (renderAreaList.find(item => item.isActive) || {})
                              .id
                          }
                        >
                          {renderAreaList.map(item => (
                            <Radio
                              value={item.id}
                              key={item.id}
                              onChange={e => {
                                this.getTourType(
                                  tag_list,
                                  item.id,
                                  e.target.value,
                                  area
                                )
                                resetScenicSpotList()
                                resetScenicSpotImg()
                                sessionServiceStore.initItineraryList([])
                                this.queryScenicSpot(
                                  (
                                    renderAreaList.find(
                                      item => item.isActive
                                    ) || {}
                                  ).mark_id,
                                  'create'
                                )
                              }}
                            >
                              {item.name}
                            </Radio>
                          ))}
                        </Radio.Group>
                      )}
                    </FormItem>
                  </div>
                  {/* 只是一个用来显示目的地错误信息的item */}
                  {!!renderAreaList.length && (
                    <div className={Style.voladate}>
                      <FormItem>
                        {getFieldDecorator('destination', {
                          initialValue: form_values.destination
                            ? form_values.destination
                            : '',
                          rules: [
                            {
                              validator: (rule, value, callback) => {
                                if (!value) {
                                  callback('请选择一个目的地')
                                }
                                callback()
                              }
                            }
                          ]
                        })(<span />)}
                      </FormItem>
                    </div>
                  )}
                </div>
              ) : (
                ''
              )}
              {property_id == 6 &&
                (weddingPhotoType == 1 && scenicSpotList.length ? (
                  <div className={Style.scenicSpot}>
                    <FormItem label="取景地" {...formItemLayout}>
                      <div
                        style={{
                          margin: '9px 0 16px 0',
                          lineHeight: '21px',
                          color: '#666666'
                        }}
                      >
                        <p>提示：</p>
                        <p>
                          1、勾选取景地后，套餐将在周边旅拍中展示，代表套餐可在以上取景地拍摄；
                        </p>
                        <p>
                          2、请上传与取景地匹配的封面图，不匹配的封面将不给予流量曝光；
                        </p>
                        <p>3、图片建议尺寸：500*500px。</p>
                      </div>
                      {getFieldDecorator('scenicSpot', {
                        initialValue:
                          form_values.scenicSpot &&
                          toJS(form_values.scenicSpot),
                        rules: [
                          {
                            type: 'array',
                            max: 3,
                            message: '最多可选择3个'
                          }
                        ]
                      })(
                        <Checkbox.Group
                          style={{ width: '100%' }}
                          onChange={e => {
                            if (e.length > 3) {
                              message.warning('最多可选择3个')
                              throw Error('最多可选择3个')
                            }
                            setTimeout(() => {
                              this.props.form.validateFields(['scenicSpotImg'])
                            }, 100)
                            removeDeletedScenicSpotList(e)
                            this.props.store.centerStore.onScenicSpotChange(e)
                          }}
                        >
                          {scenicSpotList.map(item => (
                            <Checkbox
                              style={{ margin: '0 16px 12px 0' }}
                              key={item.id}
                              value={item.id}
                            >
                              {item.name}
                            </Checkbox>
                          ))}
                        </Checkbox.Group>
                      )}
                    </FormItem>
                    <FormItem
                      style={{ marginTop: 4 }}
                      wrapperCol={{ offset: 4 }}
                    >
                      {getFieldDecorator('scenicSpotImg', {
                        initialValue:
                          form_values.scenicSpotImg &&
                          toJS(form_values.scenicSpotImg),
                        rules: [
                          {
                            validator: (rule, value, callback) => {
                              const scenicSpot = toJS(form_values.scenicSpot)
                              const val = value ? value.map(el => el.id) : []
                              if (scenicSpot.length > val.length) {
                                callback('请上传取景地封面图')
                                return
                              }
                              let r
                              scenicSpot.forEach(el => {
                                if (val.findIndex(f => f === el) === -1) {
                                  r = true
                                }
                              })
                              if (val.length === scenicSpot.length && r) {
                                callback('请上传取景地封面图')
                                return
                              }
                              let i
                              scenicSpot.forEach(el => {
                                if (val.findIndex(f => f === el) === -1) {
                                  i = true
                                }
                              })

                              if (val.length > scenicSpot.length && i) {
                                callback('请上传取景地封面图')
                                return
                              }
                              callback()
                            }
                          }
                        ]
                      })(
                        <ScenicSpotImgs
                          selected={selectedScenicSpot(scenicSpotList)}
                          scenicSpotList={scenicSpotList}
                          setScenicSpotList={list => setScenicSpot(list)}
                        />
                      )}
                    </FormItem>
                  </div>
                ) : weddingPhotoType == 4 &&
                form_values['destination'] &&
                scenicSpotList.length ? (
                  <div className={Style.scenicSpot}>
                    <FormItem label="取景地" {...formItemLayout}>
                      <div
                        style={{
                          margin: '9px 0 16px 0',
                          lineHeight: '21px',
                          color: '#666666'
                        }}
                      >
                        <p>提示：</p>
                        <p>
                          1、勾选取景地后，套餐将在周边旅拍中展示，代表套餐可在以上取景地拍摄；
                        </p>
                        <p>
                          2、请上传与取景地匹配的封面图，不匹配的封面将不给予流量曝光；
                        </p>
                        <p>3、图片建议尺寸：500*500px。</p>
                      </div>
                      {getFieldDecorator('scenicSpot', {
                        initialValue:
                          form_values.scenicSpot &&
                          toJS(form_values.scenicSpot),
                        rules: [
                          {
                            type: 'array',
                            max: 3,
                            message: '最多可选择3个'
                          }
                        ]
                      })(
                        <Checkbox.Group
                          style={{ width: '100%' }}
                          onChange={e => {
                            if (e.length > 3) {
                              message.warning('最多可选择3个')
                              throw Error('最多可选择3个')
                            }
                            setTimeout(() => {
                              this.props.form.validateFields(['scenicSpotImg'])
                            }, 100)
                            removeDeletedScenicSpotList(e)
                            this.props.store.centerStore.onScenicSpotChange(e)
                          }}
                        >
                          {scenicSpotList.map(item => (
                            <Checkbox
                              style={{ margin: '0 16px 12px 0' }}
                              key={item.id}
                              value={item.id}
                            >
                              {item.name}
                            </Checkbox>
                          ))}
                        </Checkbox.Group>
                      )}
                    </FormItem>
                    <FormItem
                      style={{ marginTop: 4 }}
                      wrapperCol={{ offset: 4 }}
                    >
                      {getFieldDecorator('scenicSpotImg', {
                        initialValue:
                          form_values.scenicSpotImg &&
                          toJS(form_values.scenicSpotImg),
                        rules: [
                          {
                            validator: (rule, value, callback) => {
                              const scenicSpot = toJS(form_values.scenicSpot)
                              const val = value ? value.map(el => el.id) : []
                              if (scenicSpot.length > val.length) {
                                callback('请上传取景地封面图')
                                return
                              }
                              let r
                              scenicSpot.forEach(el => {
                                if (val.findIndex(f => f === el) === -1) {
                                  r = true
                                }
                              })
                              if (val.length === scenicSpot.length && r) {
                                callback('请上传取景地封面图')
                                return
                              }
                              let i
                              scenicSpot.forEach(el => {
                                if (val.findIndex(f => f === el) === -1) {
                                  i = true
                                }
                              })

                              if (val.length > scenicSpot.length && i) {
                                callback('请上传取景地封面图')
                                return
                              }
                              callback()
                            }
                          }
                        ]
                      })(
                        <ScenicSpotImgs
                          selected={selectedScenicSpot(scenicSpotList)}
                          scenicSpotList={scenicSpotList}
                          setScenicSpotList={list => setScenicSpot(list)}
                        />
                      )}
                    </FormItem>
                  </div>
                ) : null)}
              {weddingPhotoType == 4 && (
                <FormItem
                  label="专项服务"
                  {...formItemLayout}
                  extra={
                    <span>非必填项，为避免消费纠纷，请如实填写专享服务</span>
                  }
                >
                  {getFieldDecorator('vip_tag_list', {
                    initialValue:
                      form_values && form_values.vip_tag_list
                        ? toJS(form_values.vip_tag_list)
                        : []
                  })(
                    <Checkbox.Group>
                      {vipTagList.map(({ id, name }) => (
                        <Checkbox key={id} value={id}>
                          {name}
                        </Checkbox>
                      ))}
                    </Checkbox.Group>
                  )}
                </FormItem>
              )}
            </FormItem>
          }
        </div>
      </div>
    )
  }
}
